import { z } from 'zod';

const createItemSchema = z.object({
  productName: z.string().min(1, 'Vui lòng nhập tên sản phẩm'),
  price: z.string().min(1, 'Vui lòng nhập giá sản phẩm'),
  quantity: z
    .number({
      required_error: 'Vui lòng nhập số lượng',
      invalid_type_error: 'Vui lòng nhập số lượng',
    })
    .min(1, 'Số lượng phải lớn hơn 0'),
  serialNumber: z
    .string()
    .min(1, 'Vui lòng nhập Serial Number')
    .min(6, 'Serial Number phải có ít nhất 6 ký tự')
    .max(50, 'Serial Number không được vượt quá 50 ký tự')
    .regex(
      /^[a-zA-Z0-9.-]+$/,
      'Serial Number chỉ được chứa chữ cái, số, dấu gạch ngang (-) và dấu chấm (.)'
    )
    .refine(
      (val) => !val.includes(' '),
      'Serial Number không được chứa khoảng trắng'
    ),
  description: z.string().optional(),
});

const editItemSchema = createItemSchema.extend({
  id: z
    .number()
    .optional()
    .or(z.string().transform((val) => Number(val))),
});

export const createOrderFormSchema = (
  _isEdit: boolean,
  hasReasonReject: boolean
) =>
  z.object({
    customerId: z.string().min(1, 'Vui lòng chọn khách hàng'),
    employeeId: z.string().min(1, 'Vui lòng chọn nhân viên'),
    items: z
      .array(_isEdit ? editItemSchema : createItemSchema)
      .min(1, 'Vui lòng thêm ít nhất một sản phẩm'),
    amountToBePaid: z
      .number()
      .optional()
      .or(z.nan().transform(() => undefined)),
    sellDate: z
      .date({
        required_error: 'Vui lòng chọn ngày bán',
      })
      .min(new Date('1900-01-01'), 'Ngày bán không hợp lệ'),
    explanation: hasReasonReject
      ? z.string().min(1, 'Vui lòng nhập lý do muốn được phê duyệt lại')
      : z.string().optional(),
    budgetMaxBuyGift: z
      .number()
      .min(1, 'Số tiền tối đa mua quà phải lớn hơn 0')
      .optional()
      .or(z.nan().transform(() => undefined)),
  });

export type OrderFormValues = z.infer<ReturnType<typeof createOrderFormSchema>>;
